import Marquee from "react-fast-marquee";

const ITEMS = [
  "Wealth × Coach",
  "Investrading Accelerator",
  "Strategic Learning",
  "Live Trading",
  "Options Strategy",
  "Financial Freedom",
];

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="py-10 border-y border-white/10 bg-surface/40 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-4xl md:text-6xl stroke-text px-8">
              {t}
            </span>
            <span className="text-burgundy text-2xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
